import { render, staticRenderFns } from "./ReferenceModal.vue?vue&type=template&id=2c5ce81f&scoped=true"
import script from "./ReferenceModal.vue?vue&type=script&lang=js"
export * from "./ReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./ReferenceModal.vue?vue&type=style&index=0&id=2c5ce81f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ce81f",
  null
  
)

export default component.exports